import React from 'react';

// Privacy Policy page for Virtual Hardhat
// TODO: Add real legal content and review for GDPR, CCPA, SOC2, HIPAA, etc.

function PrivacyPolicy() {
  return (
    <div className="max-w-3_xl mx-auto py-16 px-4">
      <h1 className="text-3_xl font-bold mb-6 text-yellow-500">Privacy Policy</h1>
      <p className="mb-4 text-gray-700">
        This is a placeholder for the Virtual Hardhat Privacy Policy. Please review and update with
        your legal team before launch.
      </p>
      <ul className="list-disc pl-6 text-gray-600">
        <li>We respect your privacy and are committed to protecting your data.</li>
        <li>All data is stored securely and only used for compliance and safety purposes.</li>
        <li>Contact support@virtual-hardhat.com for any privacy-related questions.</li>
      </ul>
      <div className="mt-8 text-sm text-gray-400">Last updated: June 2024</div>
    </div>
  );
}

export default PrivacyPolicy;
